import React, { useState, useEffect, useContext } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { LangContext } from '../../../context/lang-context'
import { NavigationContext } from '../../../context/navigation-context'
import useFetch from '../../../hooks/fetchMSSQL-hook'

import ReturnLink from '../../../components/Return/ReturnLink'

import MachineDetailsCard from '../../../components/Machine/MachineDetailsCard'

const FullMachine = () => {
  const { machineId } = useParams()
  const history = useHistory();
  const { fetchMssqlApi } = useFetch()
  const { setHeaderData } = useContext(NavigationContext)
  const { TRL_Pack } = useContext(LangContext)

  const [machineData, setMachineData] = useState({})
  // console.log(machineData)
  const getMachine = () => {
    fetchMssqlApi(`machine/${machineId}`, {}, machineData =>
      setMachineData({ ...machineData })
    )
  }

  const deleteMachine = id => {
    if (window.confirm(TRL_Pack.fullMachine.deleteMachine))
      fetchMssqlApi(`console-machine`, { method: 'DELETE', data: {machineId: machineId}}, (res) => {history.push('/machines')})
  }

  useEffect(() => {
    setHeaderData({ text: TRL_Pack.machines.header })
    getMachine()
  }, [])

  return (
    <div className='container-xl'>
      <ReturnLink path="/machines" />
      <div className="row mb-4">
          <MachineDetailsCard machineData={machineData} getMachine={getMachine} deleteMachine={deleteMachine} />
      </div>
    </div>
  )
}

export default FullMachine;